<template>

<div v-cloak>
  <div class="card" @click="click()">
    <div class="card__icon"><img src="/assets/img/icon-card-qr-code-scans.png" alt=""></div>
    <div class="card__title capitalize">{{ $_('qr_code_scans') }}</div>
    <div class="card__inner">
      <strong class="alpha" v-show="!loading">{{ Number(total).toLocaleString() }}</strong>
      <strong class="alpha" v-show="loading">&nbsp;</strong>
      <!-- <strong class="alpha" v-show="!loading">{{ total.length }}</strong> -->
      <!-- <p v-show="loading" class="flush--bottom"><i class="fa fa-spin fa-spinner"></i></p> -->
    </div>
  </div> <!-- card -->
</div>

</template>

<script>
export default {
  props: {
    startDate: String,
    endDate: String,
  },
  data () {
    return {
      user: window.user,
      client: window.client,
      loading: false,
      total: 0,
      error: null,
    }
  },
  mounted () {
    this.getQrCodes();
  },
  methods: {
    click: function() {
      window.location.href = `/clients/${this.client.id}/stats/smartqrcode?date_start=${this.startDate}&date_end=${this.endDate}`;
    },
    getQrCodes: function() {
      var self = this;
      if (!self.client.beaconstac_org_id) return;
      self.loading = true;
      const date_start = moment(self.startDate).format('YYYY-MM-DD');
      const date_end = moment(self.endDate).add(1, 'days').format('YYYY-MM-DD');
      this.$http.get(`/api/v1/${self.client.id}/qr/total?date_start=${date_start}&date_end=${date_end}`).then(
        function(response) {
          self.total = response.data.total_scans;
          self.loading = false;
        },
        function(error) {
          console.error(error);
          self.error = error;
          self.loading = false;
        }
      );
    },
  }
}

</script>

<style lang="scss" scoped>
.card {
  &:hover {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/BeaconstacCardScans.vue